module.exports = __webpack_public_path__ + "img/emo_37.bba2af0e.png";